import { forwardRef, memo } from 'react';
import { Captain } from '../../../../../components/Icons/Captain';
import { Checked } from '../../../../../components/Icons/Checked';
import { Points } from '../../../../../components/Icons/Points';
import Tooltip from '../../../../../components/Tooltip';
import { PlantelView } from '../../../../../components/Widgets/GamePlanField/PlantelView';
import { choosePlatform } from '../../../../../helpers/utils';
interface OptionItemProps {
	item: any;
	index: number;
}

const OptionReplyItemView = memo(
	forwardRef<HTMLDivElement, OptionItemProps>(({ item, index }, ref) => {
		const renderOption = (optionType: number) => {
			switch (optionType) {
				case 0:
					return (
						<div className="w-full flex flex-col gap-2">
							<div className="justify-between items-center gap-2 inline-flex">
								<div className="flex justify-start items-center gap-1.5 cursor-pointer">
									<Checked />
									<div className="text-custom-black text-sm font-semibold font-bahnschrift">
										{item.statementReply ? 'Sim' : 'Não'}
									</div>
									<div className="text-[#595959] text-[10px] leading-5 font-semibold font-bahnschrift">
										+
										{item.statementReply
											? item.winPointsYes
											: item.winPointsNo}{' '}
										pts
									</div>
								</div>
								<div>
									{item.isCanceled ? (
										<div
											className={
												'w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#a20e0e]'
											}
										>
											<div className="text-white text-xs font-normal font-bahnschrift leading-3">
												Cancelado
											</div>
										</div>
									) : item.resultStatus === 2 ||
									  item.resultStatus === 3 ? (
										<div
											className={
												'w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex ' +
												(item.resultStatus === 2
													? 'bg-[#0ea25d]'
													: 'bg-[#a20e0e]')
											}
										>
											<div className="text-white text-xs font-normal font-bahnschrift leading-3">
												{item.resultStatus === 2
													? 'Vencedora'
													: 'Perdedora'}
											</div>
										</div>
									) : (
										<div
											className={
												'w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#ea8d27]'
											}
										>
											<div className="text-white text-xs font-normal font-bahnschrift leading-3">
												Pendente
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					);
				case 1:
					return (
						<div className="w-full flex flex-col gap-2">
							<div className="pt-4">
								<PlantelView
									draftReply={item.draftReply}
									positions={item.draftPositions}
									draftResult={item.draftResult}
									modalityName={item.modality.name}
								/>
							</div>
							<div className="flex justify-end pb-1">
								{item.isCanceled ? (
									<div className="w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#a20e0e]">
										<div className="text-white text-xs font-normal font-bahnschrift leading-3">
											Cancelado
										</div>
									</div>
								) : item.resultStatus === 2 ||
								  item.resultStatus === 3 ? (
									<div
										className={
											'w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex mb-1 ' +
											(item.resultStatus === 2
												? 'bg-[#0ea25d]'
												: 'bg-[#a20e0e]')
										}
									>
										<div className="text-white text-xs font-normal font-bahnschrift leading-3">
											{item.resultStatus === 2
												? 'Vencedora'
												: 'Perdedora'}
										</div>
									</div>
								) : (
									<div
										className={
											'w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#ea8d27]'
										}
									>
										<div className="text-white text-xs font-normal font-bahnschrift leading-3">
											Pendente
										</div>
									</div>
								)}
							</div>
						</div>
					);
				case 2:
					return (
						<div className="grid grid-flow-row grid-cols-3">
							<div></div>
							<div className="flex justify-center items-center gap-2 w-full">
								<div
									className={
										'flex py-1.5 flex-col -mt-3 gap-2 text-xl text-center w-full font-semibold font-bahnschrift ' +
										(item.resultStatus === 2
											? 'text-[#0ea25d]'
											: 'text-[#a20e0e]')
									}
								>
									<div>
										{item.numberReply}{' '}
										<span
											className={
												'text-base text-center w-full font-semibold font-bahnschrift ' +
												(item.resultStatus === 2
													? 'text-[#0ea25d]'
													: 'text-[#a20e0e]')
											}
										>
											{item.draftScout
												? Number(item.numberResult) <= 1
													? item.draftScout.name
													: item.draftScout.nameSuffix
												: ''}
										</span>
									</div>
								</div>
							</div>

							<div className="flex justify-end">
								{item.isCanceled ? (
									<div
										className={
											'w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#a20e0e]'
										}
									>
										<div className="text-white text-xs font-normal font-bahnschrift leading-3">
											Cancelado
										</div>
									</div>
								) : item.resultStatus === 2 ||
								  item.resultStatus === 3 ? (
									<div
										className={
											'w-20 h-7 rounded-lg justify-center items-center inline-flex ' +
											(item.resultStatus === 2
												? 'bg-[#0ea25d]'
												: 'bg-[#a20e0e]')
										}
									>
										<div className="text-white text-xs font-normal font-bahnschrift leading-3">
											{item.resultStatus === 2
												? 'Vencedora'
												: 'Perdedora'}
										</div>
									</div>
								) : (
									<div
										className={
											'w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#ea8d27]'
										}
									>
										<div className="text-white text-xs font-normal font-bahnschrift leading-3">
											Pendente
										</div>
									</div>
								)}
							</div>
						</div>
					);
				default:
					return null;
			}
		};

		const totalPoints =
			item.draftResult &&
			Math.round(
				item.draftResult
					.filter((i: any) => !i.isReserve)
					.reduce((sum: number, player: { scoutsPoints: string }) => {
						return sum + Number(player.scoutsPoints);
					}, 0) * 100
			) / 100;

		return (
			<div
				ref={ref}
				tabIndex={-1}
				key={index}
				className="flex flex-col w-full lg:max-w-screen-xl lg:mx-auto"
			>
				<div className="bg-gray-100 rounded-lg min-h-[116px]">
					<div className="flex flex-col just gap-0.5 px-4 py-1.5">
						<div
							className={
								'self-stretch justify-end items-center gap-2.5 inline-flex ' +
								(item.optionType === 1 ? 'pt-2' : '')
							}
						>
							<div className="text-primary text-xs font-semibold font-bahnschrift">
								{item.optionType === 1 ? (
									item.resultStatus !== 1 ? (
										`${totalPoints} pontos`
									) : (
										<div className="flex gap-1.5 mt-1 -mb-1">
											<Tooltip
												icon={
													<Points className="w-4 h-4 " />
												}
												title="Pontuação"
												infoIcon="success"
												drafPoints
												draftScouts={
													item.draftScoutGroup
														?.scoutsRegistrations
												}
											/>
											{Number(item.numbersOfKicks) >
												0 && (
												<Tooltip
													icon={
														<Captain
															colorBg="#ffffff"
															colorIcon={
																choosePlatform()
																	? '#35168C'
																	: '#DF1737'
															}
															className="w-4 h-4"
														/>
													}
													title="Capitão"
													infoIcon="warning"
													message={`Nesta equipe, você pode escolher ${Number(
														item.numbersOfKicks
													)} ${
														Number(
															item.numbersOfKicks
														) > 1
															? 'capitões'
															: 'capitão'
													}, e a pontuação dele será dobrada.`}
												/>
											)}
										</div>
									)
								) : (
									`${
										item.resultStatus === 2
											? item.statementReply
												? item.winPointsYes
												: item.winPointsNo
											: '0'
									} pontos`
								)}
							</div>
						</div>
						<div className="self-stretch flex-col justify-start items-start gap-0.5 flex">
							<div className="self-stretch flex-col justify-start items-start gap-1 flex">
								<div
									className={
										'self-stretch text-custom-black text-base font-semibold font-bahnschrift' +
										(item.optionType === 1
											? ''
											: ' min-h-12')
									}
								>
									<div className="self-stretch text-custom-black text-base font-semibold font-bahnschrift">
										{item.title}
									</div>
								</div>
							</div>
						</div>

						{renderOption(item.optionType)}
					</div>
				</div>
			</div>
		);
	})
);

export default OptionReplyItemView;
